import { Loader2 } from "lucide-react";
import { BrandMark } from "@/components/common/Brand";
import { appScope } from "@/lib/tenantPath";

export function Spinner({ className = "h-5 w-5" }) {
  return <Loader2 className={`animate-spin text-zinc-400 ${className}`} />;
}

export function FullScreenLoader() {
  const own = appScope();
  return (
    <div data-testid="fullscreen-loader" className="min-h-screen flex flex-col items-center justify-center gap-4 bg-canvas">
      {own
        ? <img src={`/api/public/businesses/${own.slug}/icon-192.png`} alt="" className="h-12 w-12 rounded-2xl animate-pulse" data-testid="loader-business-icon" />
        : <BrandMark className="h-10 w-10 animate-pulse" />}
      <Spinner />
    </div>
  );
}

export function SectionLoader() {
  return (
    <div className="py-20 flex items-center justify-center" data-testid="section-loader">
      <Spinner className="h-6 w-6" />
    </div>
  );
}
